import "./Announcement.scss";
import { images } from "../../constants";

const Announcement = () => {
  return (
    <div className="announcement_container">
      <div className="announcement_head_div">
        <h3 className="announcement__head">
          SALE: Use 'SUMMER15' for Flat 15% Discount
        </h3>
      </div>
      <div className="announcement_download_div">
        <p>
          <strong>Download App</strong>
        </p>
        <img src={images.Google} alt="play" />
        <img src={images.Apple} alt="apple" />
      </div>
    </div>
  );
};

export default Announcement;
